module.exports = __webpack_public_path__ + "svg/bg-triangles-left-graph.svg";